<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { productsMethods } from '@state/helpers'
import ProductsTable from '@components/retina/products/productsTable'
import { mapGetters } from 'vuex'

export default {
  name: 'product-expiration-date',
  page: {
    title: 'Productos próximos a caducar',
    meta: [
      {
        name: 'Productos próximos a caducar',
        content: 'Check product expiration date',
      },
    ],
  },
  components: { Layout, PageHeader, ProductsTable },
  data() {
    return {
      title: '<i class="fas fa-clipboard-check"></i> Productos próximos a caducar',
      items: [
        {
          text: 'Productos',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'reference', label: 'Referencia' },
        { key: 'name', label: 'Nombre' },
        { key: 'extension', label: 'Extensión', class: 'text-nowrap' },
        { key: 'serial', label: 'Serial', class: 'text-nowrap' },
        { key: 'lote', label: 'Lote', class: 'text-nowrap' },
        { key: 'due_date', label: 'Vencimiento' },
        { key: 'warehouse_name', label: 'Bodega' },
        { key: 'ubication_name', label: 'Ubicación' },
      ],
      downloading: false,
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
    }),
  },
  methods: {
    ...productsMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchProducts(
        this.$table_params(ctx) + '&check_expiration_date=true'
      )
      return promise
        .then(response => {return response.data})
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },
    ddate(d) {
      return this.$strfDatetime(d)
    },
    expiration(d) {
      let exp = this.$datetimesDiff(Date.now(), d)
      let daydiff = exp / (1000 * 60 * 60 * 24)
      if (daydiff < 0) return 'Vencido'
      return 'Vence en ' + daydiff.toFixed(0) + ' dias'
    },
    getProductReport() {
      this.downloading = true
      let query_format =
        '?download=true' + '&check_expiration_date=true' + '&paginate=false'

      if (Boolean(this.warehouse_selected))
        query_format += '&warehouse=' + this.warehouse_selected.id
      if (Boolean(this.ubication_selected))
        query_format += '&ubication=' + this.ubication_selected.id

      this.fetchProductsReport(query_format)
        .then((response) => {
          this.downloading = false
          if (response.status == 204) {
            this.$generate_toast(
              this,
              'info',
              'La bodega no tiene productos en inventario'
            )
          } else {
            const data = response.data
            const url = URL.createObjectURL(
              new Blob([data], {
                type: 'application/vnd.ms-excel',
              })
            )
            let fileName = this.warehouse_selected
              ? this.warehouse_selected.description
              : ''
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
              'download',
              `Reporte de Productos ${fileName}.xlsx`
            )
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((error) => {
          this.downloading = false
          // console.log('Se presento un error en la descarga del archivo.', error)
          this.$axios_error_noty(error, this)
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12 col-lg-12 px-xs-0 mx-xs-0">
        <ProductsTable
          class="products_table"
          :tableheaders="tableHeaders"
          :drfprovider="myProvider"
          :enableQrSearch="false"
          :serialSearchInput="false"
        >
          <template slot="button-content">
            <b-button
              :disabled="downloading"
              @click="getProductReport()"
              variant="outline-success"
              class="mb-2"
              v-b-tooltip.hover="{
                variant: 'success',
                title: 'Descargar Excel',
              }"
            >
              <i v-if="!downloading" class="fas fa-file-excel fa-lg"></i> <span v-if="!downloading" class="d-none d-md-inline"> Excel</span>
              <span
                v-if="downloading"
                class="spinner-border spinner-border-sm text-success"
                role="status"
              >
              </span>
              <span v-if="downloading" class="d-none d-md-inline" > Descargando ... </span>
            </b-button>
          </template>
          <template v-slot:cell(extension)="data">
            {{ data.item.ext_description }} {{ data.item.ext_detail }}
          </template>
          <template v-slot:cell(due_date)="data">
            {{ ddate(data.item.due_date).substr(0, 10) }}
            <b-badge
              v-if="expiration(data.item.due_date) == 'Vencido'"
              variant="danger"
              >{{ expiration(data.item.due_date) }}</b-badge
            >
            <b-badge v-else variant="warning">{{
              expiration(data.item.due_date)
            }}</b-badge>
          </template>
        </ProductsTable>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
.products_table .multiselect__option {
  white-space: normal;
  font-weight: 300;
  font-size: 14px;
}
</style>
